module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-hyundai.dfbf034b.png";